import { useQueries } from "@tanstack/react-query";
import { artifactMarkdownQuery } from "@/lib/artifactMarkdown";
import type { Artifact } from "@/services/projectsApi";

/** Markdown for each artefact, keyed by uid, plus the uids still loading.
 *  Each artefact is fetched once per version and cached (see artifactMarkdownQuery). */
export function useArtifactMarkdown(projectId: string, artifacts: Artifact[]) {
  const results = useQueries({
    queries: artifacts.map((a) => artifactMarkdownQuery(projectId, a)),
  });

  const markdownByUid: Record<string, string> = {};
  const loadingUids = new Set<string>();
  results.forEach((result, i) => {
    const uid = artifacts[i].uid;
    if (result.isPending) loadingUids.add(uid);
    else markdownByUid[uid] = result.data ?? "";
  });

  return { markdownByUid, loadingUids };
}
